import React, { useState, useEffect, Fragment } from 'react'
import { injectIntl } from 'react-intl'

import ProductSuggestionsCard, {
  ProductSuggestionsCardLoading,
} from './ProductSuggestionsCard'
import { SuggestionsStatus } from './typings'

import { getAccountName } from '@/checkout-instore-legacy/utils/UrlUtils'
import { skeletonLoading } from '@/checkout-instore-legacy/components/Commons/ProductAvailabilityInfo/utils'
import { PAGE_SIZE } from '@/checkout-instore-legacy/constants/ProductSuggestionsConstants'

export interface ProductSuggestionsShowcaseProps {
  title: string
  getSuggestions: (simulationAddress: Address) => Promise<Product[]>
  simulationAddress: Address
  intl: any
}

function ProductSuggestionsShowcase({
  title,
  getSuggestions,
  simulationAddress,
  intl,
}: ProductSuggestionsShowcaseProps) {
  const [products, setProducts] = useState<Product[]>([])
  const [status, setStatus] = useState<SuggestionsStatus>('disabled')

  const storeName = getAccountName()

  const listProducts = products.map((product: Product) => (
    <Fragment key={product.id}>
      <ProductSuggestionsCard product={product} />
    </Fragment>
  ))

  useEffect(() => {
    async function fetchData() {
      setStatus('loading')
      const response = await getSuggestions(simulationAddress)
      setProducts(response)
      setStatus('resolved')
    }
    fetchData()
  }, [getSuggestions, simulationAddress])

  return (
    <div id="suggestion-component" className="ma5">
      {status === 'loading' ? (
        <ShowcaseLoading />
      ) : (
        <>
          <p className="f5-s mv7">
            {title} {intl.formatMessage({ id: 'in' })}{' '}
            <span className="b">{storeName}</span>
          </p>
          <div
            className={`flex flex-row hide-scrollbar overflow-scroll`}
            id="suggested-products"
          >
            {listProducts}
          </div>
        </>
      )}
    </div>
  )
}

const ShowcaseLoading = () => {
  const LoadingCards = Array(PAGE_SIZE)
    .fill('')
    .map((_val, index) => <ProductSuggestionsCardLoading key={index} />)

  return (
    <span id="suggestions-loading">
      <div className="mv7">{skeletonLoading}</div>
      <div className="flex flex-row hide-scrollbar overflow-scroll`">
        {LoadingCards}
      </div>
    </span>
  )
}

export default injectIntl(ProductSuggestionsShowcase)
